class AccordionItem extends HTMLElement {
    constructor() {
        super();
    }

    open() {
        const content = this.querySelector("[data-accordion-content]");
        content.style.maxHeight = content.scrollHeight + "px";

        this.setAttribute("data-open", "true");
    }

    close() {
        const content = this.querySelector("[data-accordion-content]");
        content.style.maxHeight = "0px";

        this.setAttribute("data-open", "false");
    }
}

customElements.define("accordion-item", AccordionItem);

class AccordionItemHeading extends HTMLElement {
    connectedCallback() {
        this.addEventListener("click", this.toggleAccordionItem);
    }

    disconnectedCallback() {
        this.removeEventListener("click", this.toggleAccordionItem);
    }

    toggleAccordionItem = () => {
        const currentItem = this.closest("accordion-item");
        const isOpen = currentItem.getAttribute("data-open") === "true";

        if (isOpen) {
            currentItem.close();
        } else {
            currentItem.open();
        }
    };
}

customElements.define("accordion-item-heading", AccordionItemHeading);